import React from "react";
import { UsersList } from "../UsersList";

export const CustomersList = () => <UsersList viewType="customers" />;
